import { Platform } from 'react-native';
import * as ScreenOrientation from 'expo-screen-orientation';

export const changeScreenOrientation = async () => {
  if (Platform.OS === 'web') return;
  await ScreenOrientation.lockAsync(
    ScreenOrientation.OrientationLock.LANDSCAPE_RIGHT
  );
};
